import {compact} from 'underscore';

import {ProcessFlowchartNodeDetailsType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ProcessInteractiveFlowchart} from 'processes/graph-builder-processes/flowchart-viz/ProcessFlowchartVizConstants';
import {
  ProcessRouterNodeForValidation,
  ProcessFlowchartForValidation,
  ProcessNodeForValidation,
} from 'processes/graph-builder-processes/validation/ProcessFlowchartForValidationTypes';
import {ProcessFlowchartEdgeType} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorConstants';

export function flowchartHasChainedRouters(flowchart: ProcessInteractiveFlowchart | null): boolean {
  if (flowchart == null) {
    return false;
  }
  const flowchartForValidation: ProcessFlowchartForValidation = {
    id: flowchart.clientId,
    nodes: flowchart.nodes.map(
      (node) =>
        ({
          ...node,
          id: node.clientId,
          nodeType: node.type as ProcessFlowchartNodeDetailsType,
        }) as ProcessNodeForValidation
    ),
    edges: flowchart.edges.map((edge) => ({
      ...edge,
      id: edge.clientId,
      type: ProcessFlowchartEdgeType.CONTROL_FLOW,
      target: edge.toNodeClientId,
      source: edge.fromNodeClientId,
    })),
  };

  for (const node of flowchartForValidation.nodes) {
    if (node.nodeType === ProcessFlowchartNodeDetailsType.ROUTER_NODE_DETAILS) {
      if (isRouterChained(node, flowchartForValidation)) {
        return true;
      }
    }
  }
  return false;
}

export function isRouterChained(
  node: ProcessRouterNodeForValidation,
  flowchart: ProcessFlowchartForValidation
): boolean {
  const incomingEdges = flowchart.edges.filter(({target}) => target === node.id);
  const parentNodes = compact(incomingEdges.map(({source}) => flowchart.nodes.find(({id}) => id === source)));
  const parentRouterNodes = parentNodes.filter(
    ({nodeType}) => nodeType === ProcessFlowchartNodeDetailsType.ROUTER_NODE_DETAILS
  );

  const outgoingEdges = flowchart.edges.filter(({source}) => source === node.id);
  const childNodes = compact(outgoingEdges.map(({target}) => flowchart.nodes.find(({id}) => id === target)));
  const childRouterNodes = childNodes.filter(
    ({nodeType}) => nodeType === ProcessFlowchartNodeDetailsType.ROUTER_NODE_DETAILS
  );
  return parentRouterNodes.length > 0 || childRouterNodes.length > 0;
}
